import { type PropsWithChildren } from 'react';
import './blocks/AccordionHeader.scss';

export type AccordionHeaderProps = PropsWithChildren<{
	description?: string | React.ReactNode;
}>;

export function AccordionHeader({ children, description }: AccordionHeaderProps) {
	return (
		<div className="[ accordion__header ] [ d-flex d-flex-column pb-sm gap-2xs ]">
			{children && (
				<div className="d-flex items-center justify-between w-full">
					{typeof children === 'string' ? <h2 className="text-list-heading color-text-primary">{children}</h2> : children}
				</div>
			)}
			{description && (
				<div>{typeof description === 'string' ? <p className="text-body color-text-primary">{description}</p> : description}</div>
			)}
		</div>
	);
}
